module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_06_6NV26_1SA_GJI.4e7113ae.png";